import { useState, Fragment, useEffect } from "react";

import Event from "../event/list";
import EventFieldMaker from "./EventFieldMaker";
import axios from "axios";
import AcademySelect from "../academy/select";
import managerStyle from "manager/manager.module.css"
import omegaStyle from "../omega.module.css";
import formStyle from "./form.module.css"


export const uniqueCode = () => Date.now().toString(36) + Math.random().toString(36).substring(2, 9);

function EventMaker() {
	const [templates, setTemplates] = useState([]);
	const [templateId, setTemplateId] = useState("");
	const [hasForm, setHasForm] = useState(0);
	const [name, setName] = useState("");
	const [description, setDescription] = useState("");
	const [fields, setFields] = useState([]);
	const [attributes, setAttributes] = useState({});

	const [branchList, Set_branchList] = useState([]);
	const [includeMode, Set_includeMode] = useState(false);
	const [isOpen, Set_isOpen] = useState(true);
	const [searchEvent, Set_searchEvent] = useState("");
    const [onlyEnrolled, Set_onlyEnrolled] = useState(false)
    const [startDay, Set_startDay] = useState('')
    const [endDay, Set_endDay] = useState('')

	useEffect(() => {
		get_event();
	}, []);

	async function get_event() {
		axios
			.post("/omega/form/load", {
				searchEvent: searchEvent,
			})
			.then((res) => {
				setTemplates(res.data);
			});
	}

	const addField = () => {
		setFields((prev) => [...prev, { code: uniqueCode(), type: "", options: [] }]);
	};

	const removeField = (code) => {
		setFields((prev) => prev.filter((f) => f.code !== code));
	};

	const updateField = (code, patch) => {
		// patch: { type? , options? }
		setFields((prev) => prev.map((f) => (f.code === code ? { ...f, ...patch } : f)));
	};

	const onSubmit = () => {
		if (name === "") {
			alert("행사 이름을 입력해 주세요.");
		} else if (
			(templateId === "" && window.confirm("등록하시겠습니까?")) ||
			(templateId !== "" && window.confirm("수정하시겠습니까?"))
		) {
			axios
				.post("/omega/form/save", {
					templateId,
					name,
					description,
					fields,
					attributes,
					branchList,
					includeMode,
					isOpen,
                    onlyEnrolled,
                    startDay,
                    endDay
				})
				.then((res) => {
					alert("등록되었습니다.");
					let newId = res.data.templateId;
					const template = templates.find((t) => t.id === Number(newId));
					if (template) {
						template.name = name;
						template.description = description;
						template.EventFields = fields;
						template.attributes = attributes;
					} else {
						templates.push({
							id: newId,
							name,
							description,
							EventFields: fields,
							attributes,
							updatedAt: new Date().toISOString(),
							isOpen: true,
                            onlyEnrolled: false,
                            includeMode: false,
                            branchList: [],
                            startDay: '',
                            endDay: ''
						});
					}
					setTemplates([...templates]);
				});
		}
	};

	const changeTemplate = (e) => {
		const selectedId = e.currentTarget.id;
		if (selectedId !== "") {
			const template = templates.find((t) => t.id === Number(selectedId)); // id가 숫자면 변환

			setTemplateId(template.id);
			setHasForm(template.hasForm);
			setName(template.name);
			setDescription(template.description || "");
			setAttributes(template.attributes || {});
			let currfields = template.EventFields.map((v) => {
				return { code: uniqueCode(), ...v };
			});
			setFields(currfields);
			Set_branchList(template["branchList"]);
			Set_includeMode(template["includeMode"]);
			Set_isOpen(template["isOpen"]);
            Set_onlyEnrolled(template["onlyEnrolled"])
            Set_startDay(template['startDay'] === null ? '' : template['startDay'])
            Set_endDay(template['endDay'] === null ? '' : template['endDay'])
		} else {
			setTemplateId("");
			setHasForm(0);
			setName("");
			setDescription("");
			setAttributes({});
			setFields([]);
			Set_branchList([]);
			Set_includeMode(false);
			Set_isOpen(true);
            Set_onlyEnrolled(false)
            Set_startDay('')
            Set_endDay('')
		}
	};

	const deleteTemplate = () => {
		if (window.confirm("삭제하시겠습니까?")) {
			axios.post("/omega/form/delete", { templateId }).then((res) => {
				alert("삭제되었습니다.");
				setName("");
				setDescription("");
				setTemplates((prev) => [...prev.filter((v) => v.id !== templateId)]);
				setFields([]);
				setTemplateId("");
				setAttributes({});
				setHasForm(0);
			});
		}
	};

	return (
		<div>
            <div className={omegaStyle['contentTop']}>
                <Event
                    templates={templates}
                    templateId={templateId}
                    changeTemplate={changeTemplate}
                    searchEvent={searchEvent}
                    Set_searchEvent={Set_searchEvent}
                    get_event={get_event}
                ></Event>
            </div>

            <div className={omegaStyle['contentBottom']}>
                <div className={formStyle['formWrap']}>
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "space-between",
                            marginBottom: "10px"
                        }}
                    >
                        <div
                            style={{
                                display: "flex"
                            }}
                        >
                            <button
                                className={
                                    managerStyle['button']
                                    + ' ' +
                                    managerStyle['primary']
                                }
                                onClick={onSubmit}
                            >
                                {templateId === "" && <span>행사 등록</span>}
                                {templateId !== "" && <span>행사 수정</span>}
                            </button>
                            <div style={{marginInline: "5px"}}></div>
                            {templateId !== "" && !hasForm &&
                                <button
                                    className={
                                        managerStyle['button']
                                        + ' ' +
                                        managerStyle['danger']
                                    }
                                    onClick={deleteTemplate}
                                >행사 삭제</button>
                            }
                        </div>

                        <div>
                            <button
                                type="button"
                                className={
                                    managerStyle['button']
                                    + ' ' +
                                    managerStyle['info']
                                }
                                id=""
                                onClick={(e) => changeTemplate(e)}
                            >신규</button>
                        </div>
                    </div>

                    <div
                        style={{
                            display: "flex",
                            marginBottom: "10px"
                        }}
                    >
                        <div className={formStyle['propertyWrap']}>
                            <div className={formStyle['label'] + ' ' + formStyle['required']}>행사 이름</div>
                            <div
                                className={formStyle['input_text']}
                                style={{
                                    width: "200px"
                                }}
                            >
                                <input type="text" value={name} onChange={(e) => setName(e.target.value)} />
                            </div>
                        </div>

                        <div className={formStyle['propertyWrap']}>
                            <div className={formStyle['label']}>행사 설명</div>
                            <div
                                className={formStyle['input_text']}
                                style={{
                                    width: "300px"
                                }}
                            >
                                <input type="text" value={description} onChange={(e) => setDescription(e.target.value)} />
                            </div>
                        </div>

                        <div className={formStyle['propertyWrap']}>
                            <div className={formStyle['label']}>행사 공개</div>
                            <div className={formStyle['input_checkbox']}>
                                <input type="checkbox" checked={isOpen} onChange={(e) => Set_isOpen(e.currentTarget.checked)}></input>
                            </div>
                        </div>

                        <div className={formStyle['propertyWrap']}>
                            <div className={formStyle['label']}>재원생만</div>
                            <div className={formStyle['input_checkbox']}>
                                <input type="checkbox" checked={onlyEnrolled} onChange={(e) => Set_onlyEnrolled(e.currentTarget.checked)}></input>
                            </div>
                        </div>
                    </div>

                    <div
                        style={{
                            display: "flex",
                            marginBottom: "10px"
                        }}
                    >
                        <div className={formStyle['propertyWrap']}>
                            <div className={formStyle['label']}>시작일</div>
                            <div className={formStyle['input_date']}>
                                <input
                                    type="date"
                                    value={startDay}
                                    onInput={(e) => Set_startDay(e.currentTarget.value)}
                                ></input>
                            </div>
                        </div>

                        <div className={formStyle['propertyWrap']}>
                            <div className={formStyle['label']}>종료일</div>
                            <div className={formStyle['input_date']}>
                                <input
                                    type="date"
                                    value={endDay}
                                    onInput={(e) => Set_endDay(e.currentTarget.value)}
                                ></input>
                            </div>
                        </div>
                    </div>

                    <AcademySelect
                        templateId={templateId}
                        branchList={branchList}
                        Set_branchList={Set_branchList}
                        includeMode={includeMode}
                        Set_includeMode={Set_includeMode}
                    ></AcademySelect>
                </div>

                <div className={formStyle['formWrap']}>
                    <div style={{ marginBottom: "10px" }}>
                        <button
                            className={
                                managerStyle['button']
                                + ' ' +
                                managerStyle['dark']
                            }
                            onClick={addField}
                        >필드 추가</button>
                    </div>

                    <div
                        style={{
                            overflowX: "hidden",
                            overflowY: "auto"
                        }}
                    >
                        {fields.map((field) => (
                            <Fragment key={field.code}>
                                <EventFieldMaker
                                    field={field}
                                    onPatch={(code, patch) => updateField(code, patch)} // 이미 있으니 그대로 사용
                                    onRemove={(code) => removeField(code)}
                                />
                            </Fragment>
                        ))}

                        {fields.length === 0 && <div>추가한 필드가 없습니다.</div>}
                    </div>
                </div>
            </div>
		</div>
	);
}

export default EventMaker;
